module.exports = __webpack_public_path__ + "static/media/antennaIcon.b1dd8575.svg";